export type Room = {
  id: number
  room_category: number
  number: number
  floor: number
  building: number
  notes: string
}

export const URL = '/v2/pms/accomodations/:id/rooms/'

export type Req = void

export type Resp = {
  results: Room[]
}
